import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useGetCcrcTpDetail } from 'app/model';

import { BottomButton } from '../Button/BottomButton';

import './AgreementDetail.css';
export const AgreementDetail = ({ ccrcGuidId, hspId, hspCd, onSubmit, useData = false }) => {
  const navigate = useNavigate();

  const { data: ccrcDetailRes } = useGetCcrcTpDetail({
    ccrcGuidId,
    hspId,
    hspCd,
  });

  const { desc, mainTitl, mainTitlDtl, subCcrc } = !useData ? ccrcDetailRes : ccrcDetailRes.data;

  const handleSubTitlDtlClick = (subTitlDtlLinkUrl) => {
    window.location.href = subTitlDtlLinkUrl;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className='common-agree-detail bottom-footer'>
        <h2 className='title'>{mainTitl}</h2>
        <div className='desc' dangerouslySetInnerHTML={{ __html: mainTitlDtl.replace(/\n/g, '<br />') }}></div>
        {subCcrc?.map((item, _idx) => (
          <div className='section' key={_idx}>
            <div className='section-title2'>{item.subTitl}</div>
            <p
              className={`text2 ${item.subTitlDtlLinkUrl ? 'blue-text' : ''}`}
              onClick={() => handleSubTitlDtlClick(item.subTitlDtlLinkUrl)}
            >
              {item.subTitlDtl}
            </p>
          </div>
        ))}
        <div className='desc bottom'>{desc}</div>
      </div>

      <BottomButton
        variant={'primary'}
        label='확인'
        onClick={() => {
          if (onSubmit) onSubmit();
          else navigate(-1);
        }}
      />
    </>
  );
};

